const config = {
  baseURLProd:'https://decamawebapp-bpecb5cwf6fte7he.uksouth-01.azurewebsites.net/api/',
  baseURLDev: 'http://localhost:5075/api/',
};
export default config;

//prod : https://decamawebapp-bpecb5cwf6fte7he.uksouth-01.azurewebsites.net/api/
//uat : https://decama-web-uat.azurewebsites.net/api/